"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ppaLabelTypes = exports.isPpaLabel = void 0;
var _common = require("../../common");
const ppaLabelTypes = exports.ppaLabelTypes = new Set([_common.COMING_SOON, _common.LAST_CHANCE, _common.LOW_STOCK, _common.NO_LONGER_FOR_SALE, _common.NOT_SOLD_ONLINE, _common.OUT_OF_STOCK, _common.SALE_LIMITATION, _common.SOLD_OUT, _common.UNTIL_STOCK_LASTS, _common.VALUE_SET]);
const isPpaLabel = label =>
// Type casting used so that there can be type checking in PPA_LABEL_TYPES and yet it can
// be used for checking whether label has type PpaLabelType.
ppaLabelTypes.has(label ?? '');
exports.isPpaLabel = isPpaLabel;
